import { spinnerDefaultStyle } from './spinnerDefaultStyle';
export const spinnerStyleBuilder = theme => {
  const style = spinnerDefaultStyle(theme);
  return style;
};